import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { heading4Obj } = typographyStyles;
const {
  colors: { ui },
} = constants;
const greyLight = ui.neutral[100];
const greyExtraLight = ui.neutral[25];
const greyLightBorder = `1px solid ${ui.neutral[100]}`;

export const tableRootCss: CSSObject = {
  div: {
    "h2 + div": {
      display: "none",
    },
  },
};

export const tableContainerCss: CSSObject = {
  "&:after": {
    borderColor: greyLight,
  },
};

export const tableCss: CSSObject = {
  minWidth: "100%",
  thead: {
    th: {
      verticalAlign: "top",
    },
  },
  tbody: {
    tr: {
      ":nth-of-type(odd)": {
        backgroundColor: greyExtraLight,
        th: {
          backgroundColor: greyExtraLight,
        },
      },
    },
  },
  th: {
    textDecoration: "none",
  },
  "td, th": {
    minWidth: "auto",
    padding: "8px 16px",
    textAlign: "left",
    borderBottom: greyLightBorder,
    fontWeight: 400,
    fontSize: "14px",
    width: "1%", // Scale columns to content width by default
    whiteSpace: "pre-wrap",

    button: {
      textAlign: "left",
      lineHeight: "150%",
      alignItems: "start",
      justifyContent: "space-between",
      width: "100%",
    },

    ":nth-of-type(1)": {
      whiteSpace: "nowrap",
      button: {
        fontWeight: 700,
      },
    },
  },
};

export const getColumnScaleWidthCSS = (
  columnScaleWidths: number[],
): CSSObject => {
  const columnScaleWidthsCss: CSSObject = {};

  columnScaleWidths.forEach((width, index) => {
    columnScaleWidthsCss[`&:nth-of-type(${index + 1})`] = {
      width: `${width}%`,
    };
  });

  return {
    "td, th": {
      ...columnScaleWidthsCss,
    },
  };
};

export const filterContainer: CSSObject = {
  display: "flex",
  flexDirection: "row",
  gap: "16px",
};

export const emptyDataCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "36px",
  paddingBottom: "36px",
  border: `1px solid ${greyLight}`,
  fontWeight: 700,
  ...heading4Obj,
};

export const tablePaginationCss: CSSObject = {
  root: {
    boxShadow: "none",
    borderWidth: "1px",
  },
};
